<template>
	<div class="content-block chat-messages">
		<div
			:class="{
				'chat-messages__container': true,
				'chat-messages__container--empty': isEmpty
			}"
		>
			<app-loader v-if="isLoading && !props.dialogs.length" />
			<chat-dialogs-empty
				v-else-if="isEmpty"
				@on-create="onCreateChat"
			/>
			<template
				v-for="(dialog, index) in props.dialogs"
				:key="dialog.Id"
			>
				<chat-dialog
					:dialog="dialog"
					@on-open="onOpenDialog"
					@on-delete="onDeleteDialog"
				/>
				<div
					v-if="index < dialogs.length - 1"
					class="chat-messages__container-divider"
				/>
			</template>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
	useRoute,
	useRouter
} from "vue-router";
import {
	ChatModes,
	chatsStore,
	Dialog
} from "@/store/chats";
import ChatDialog from "@/components/main/chat-panel/ChatDialog.vue";
import ChatDialogsEmpty from "@/components/main/chat-panel/ChatDialogsEmpty.vue";
import AppLoader from "@/components/common/AppLoader.vue";


type ChatMessagesPanelProps = {
	loading: boolean;
	dialogs: Dialog[],
	mode: ChatModes
}

const props = defineProps<ChatMessagesPanelProps>()
const route = useRoute()
const router = useRouter()
const store = chatsStore()
const emit = defineEmits<{
	(e: 'on-open', value: Dialog): void,
	(e: 'on-delete', value: number): void,
}>()

const isLoading = computed(() => store.loadingDialogs)
const isEmpty = computed(() => store.dialogsLoaded && !isLoading.value && !props.dialogs.length)

const onOpenDialog = (dialog: Dialog) => emit("on-open", dialog)
const onDeleteDialog = (dialogId: number) => emit("on-delete", dialogId)

const onCreateChat = async () => {
	await router.push({
		path: '/',
		query: {
			...route.query,
			mode: 'create-chat'
		}
	});
	store.setMode('create-chat')
	store.setOpenedChat(null)
}

</script>

<style scoped lang="scss">
.chat-messages {
	background: #fff;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
	padding: 0;
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;

	&__container {
		display: flex;
		flex-direction: column;
		flex: 1;
		position: relative;
		min-height: 0;
		max-height: 100%;
		padding: 8px;
		overflow-y: auto;

		&--empty {
			padding: 0;
		}

		&-divider {
			margin: 4px 16px 4px 42px;
			border-bottom: 1px solid #F2F2F2;
		}
	}
}
</style> 
